import colors from './colors';
import breakpoints from './breakpoints';
import spacing from './spacing';
import transitions from './transitions';
import typography from './typography';
import borders from './borders';
import shadows from './shadows';


export default {
    ...spacing,
    ...breakpoints,
    ...colors,
    ...transitions,
    ...typography,
    ...borders,
    ...shadows,
};
